import { myAxios } from '../../util/myAxios';
import { Page, Pageable, toUrlParams } from '../../api/pageable';
import { log } from '../../logConfig';
import { QuestionCatalogueDto, QuestionCatalogueRequest } from './qustionCatalogueTypes';
import { QuestionModuleDto, QuestionModuleRequest } from '../questionModuleTypes';
import { QuestionClusterDto, QuestionClusterRequest } from '../questionClusterTypes';
import { QuestionDto, QuestionRequest } from '../questionTypes';
import { ChoiceDto, ChoiceRequest } from '../choiceTypes';
import { isValidationErrorResponse, ValidationErrors } from '../../api/restApi';
import { AxiosResponse } from 'axios';

export function getQuestionCatalogues(
  params: { searchText?: string },
  pageable: Pageable): Promise<Page<QuestionCatalogueDto>> {
  const searchParam = params.searchText === undefined ? '' : `search=${encodeURIComponent(params.searchText)}&`;
  return myAxios()
    .then(axios => axios.get(`/api/v1/catalogue?${searchParam}` + toUrlParams(pageable)))
    .then(response => response.data, reason => log.info('nö' + reason.response.status));
}

export function createCatalogue(catalogue: QuestionCatalogueRequest): Promise<QuestionCatalogueDto | ValidationErrors> {
  return myAxios()
    .then(axios => axios.post('/api/v1/catalogue', catalogue))
    .then(
      response => response.data,
      error => {
        const response: AxiosResponse = error.response;
        if (isValidationErrorResponse(response)) {
          return response.data;
        } else {
          throw error;
        }
      }
    )
}

export function getModules(
  params: { searchText?: string },
  pageable: Pageable): Promise<Page<QuestionModuleDto>> {
  const searchParam = params.searchText === undefined ? '' : `search=${encodeURIComponent(params.searchText)}&`;
  return myAxios()
    .then(axios => axios.get(`/api/v1/module?${searchParam}` + toUrlParams(pageable)))
    .then(response => response.data, reason => log.info('nö' + reason.response.status));
}

export function createModule(module: QuestionModuleRequest): Promise<QuestionModuleDto | ValidationErrors> {
  return myAxios()
    .then(axios => axios.post('/api/v1/module', module))
    .then(
      response => response.data,
      error => {
        const response: AxiosResponse = error.response;
        if (isValidationErrorResponse(response)) {
          return response.data;
        } else {
          throw error;
        }
      }
    )
}

export function getClusters(
  params: { searchText?: string },
  pageable: Pageable): Promise<Page<QuestionClusterDto>> {
  const searchParam = params.searchText === undefined ? '' : `search=${encodeURIComponent(params.searchText)}&`;
  return myAxios()
    .then(axios => axios.get(`/api/v1/cluster?${searchParam}` + toUrlParams(pageable)))
    .then(response => response.data, reason => log.info('nö' + reason.response.status));
}

export function createCluster(cluster: QuestionClusterRequest): Promise<QuestionClusterDto | ValidationErrors> {
  return myAxios()
    .then(axios => axios.post('/api/v1/cluster', cluster))
    .then(
      response => response.data,
      error => {
        const response: AxiosResponse = error.response;
        if (isValidationErrorResponse(response)) {
          return response.data;
        } else {
          throw error;
        }
      }
    )
}

export function getQuestions(
  params: { searchText?: string },
  pageable: Pageable): Promise<Page<QuestionDto>> {
  const searchParam = params.searchText === undefined ? '' : `search=${encodeURIComponent(params.searchText)}&`;
  return myAxios()
    .then(axios => axios.get(`/api/v1/question?${searchParam}` + toUrlParams(pageable)))
    .then(response => response.data, reason => log.info('nö' + reason.response.status));
}

export function createQuestion(question: QuestionRequest): Promise<QuestionDto | ValidationErrors> {
  return myAxios()
    .then(axios => axios.post('/api/v1/question', question))
    .then(
      response => response.data,
      error => {
        const response: AxiosResponse = error.response;
        if (isValidationErrorResponse(response)) {
          return response.data;
        } else {
          throw error;
        }
      }
    )
}

export function getChoices(
  pageable: Pageable): Promise<Page<ChoiceDto>> {
  return myAxios()
    .then(axios => axios.get(`/api/v1/choice?` + toUrlParams(pageable)))
    .then(response => response.data, reason => log.info('nö' + reason.response.status));
}

export function createChoice(choice: ChoiceRequest): Promise<ChoiceDto | ValidationErrors> {
  return myAxios()
    .then(axios => axios.post('/api/v1/choice', choice))
    .then(
      response => response.data,
      error => {
        const response: AxiosResponse = error.response;
        if (isValidationErrorResponse(response)) {
          return response.data;
        } else {
          throw error;
        }
      }
    )
}
